// Prospects click link from SMS or email, so they will never have referrer
export const useIsAgent = () => document.referrer.length > 0
